import { useEffect } from 'react';

/**
 * Close a modal when the user presses Escape. Pass the same `onClose` you
 * wire to the modal's ✕ button — no-op if `enabled` is false (handy when
 * `onClose` represents something that shouldn't fire while a sub-action is
 * busy).
 *
 *   const [open, setOpen] = useState(false);
 *   useEscapeClose(open, () => setOpen(false));
 */
export default function useEscapeClose(enabled, onClose) {
    useEffect(() => {
        if (!enabled || typeof onClose !== 'function') return;
        const handler = (e) => {
            if (e.key !== 'Escape') return;
            // Inline editors that need to catch Escape themselves (e.g. inline
            // rename on a category row) can stopPropagation on their own
            // handler — the event never bubbles up to window and we stay put.
            onClose();
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [enabled, onClose]);
}
